import { Routes, Route, Navigate } from 'react-router-dom';
import EmployeeLayout from '../components/employee/EmployeeLayout.jsx';
import EmployeeDashboard from './employee/EmployeeDashboard.jsx';
import NewRequestPage from './employee/NewRequestPage.jsx';
import MyRequestsPage from './employee/MyRequestsPage.jsx';
import RequestDetailPage from './employee/RequestDetailPage.jsx';
import MyExpenseReportsPage from './employee/MyExpenseReportsPage.jsx';
import NewExpenseReportPage from './employee/NewExpenseReportPage.jsx';
import ExpenseReportDetailPage from './employee/ExpenseReportDetailPage.jsx';
import TeamCalendarPage from './employee/TeamCalendarPage.jsx';
import MyContractPage from './employee/MyContractPage.jsx';
import MyDocumentsPage from './employee/MyDocumentsPage.jsx';
import MyVisasPage from './employee/MyVisasPage.jsx';
import MyTravelPage from './employee/MyTravelPage.jsx';
import NewTravelRequestPage from './employee/NewTravelRequestPage.jsx';
import TravelDetailPage from './employee/TravelDetailPage.jsx';
import PlannerPage from './employee/PlannerPage.jsx';
import ManagerTeamView from './employee/ManagerTeamView.jsx';
import HelpPage from './employee/HelpPage.jsx';
import GuidedTour from '../components/onboarding/GuidedTour.jsx';
import { EMPLOYEE_TOUR_STEPS } from '../components/onboarding/tourSteps.js';

export default function EmployeePage() {
  return (
    <>
      <Routes>
        <Route element={<EmployeeLayout />}>
          <Route index element={<EmployeeDashboard />} />
          <Route path="planner" element={<PlannerPage />} />
          <Route path="request" element={<NewRequestPage />} />
          <Route path="my-requests" element={<MyRequestsPage />} />
          <Route path="my-requests/:id" element={<RequestDetailPage />} />
          <Route path="team-calendar" element={<TeamCalendarPage />} />
          <Route path="team-overview" element={<ManagerTeamView />} />
          <Route path="my-contract" element={<MyContractPage />} />
          <Route path="my-documents" element={<MyDocumentsPage />} />
          <Route path="my-visas" element={<MyVisasPage />} />
          <Route path="my-visas/:id" element={<MyVisasPage />} />
          <Route path="travel" element={<MyTravelPage />} />
          <Route path="travel/new" element={<NewTravelRequestPage />} />
          <Route path="travel/:id" element={<TravelDetailPage />} />
          <Route path="expenses" element={<MyExpenseReportsPage />} />
          <Route path="expenses/new" element={<NewExpenseReportPage />} />
          <Route path="expenses/:id" element={<ExpenseReportDetailPage />} />
          <Route path="help" element={<HelpPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
      <GuidedTour steps={EMPLOYEE_TOUR_STEPS} storageKey="prohr_employee_tour_done" />
    </>
  );
}
